import { useEffect, useState } from "react";
import Button from "../extra/Button";
import Input from "../extra/Input";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../store/admin/admin.action";
import { connect } from "react-redux";
import { Copy } from "lucide-react";
import MoonLiveShop from "../../assets/images/MoonLiveShopImage.png"
import { projectName } from "../../util/config";

const Login = (props) => {
  const navigate = useNavigate();

  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState({
    email: "",
    password: "",
  });



  const handleSubmit = async () => {
    if (isLoading) return;
    if (!email || !password) {
      let error = {};
      if (!email) error.email = "Email Is Required !";
      if (!password) error.password = "password is required !";
      return setError({ ...error });
    } else {
      let login = {
        email,
        password,
      };

      setIsLoading(true);
      try {
        const res = await props.loginAdmin(login, navigate);
        if (!res) {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };


  return (
    <>
      <div className="mainLoginPage">
        <div className="loginDiv">
          <div className="row">
            <div
              className="col-xl-6 d-xxl-block d-xl-block d-none boxCenter"
            >
              {/* <div
                className="p-5"
                style={{
                  // background: "#DEF213",
                }}
              > */}
              <img
                className="img-fluid"
                src={MoonLiveShop}
                alt="text logo"
                srcset=""
              />
              {/* </div> */}
            </div>
            <div className="col-xl-6 col-md-12 boxCenter"
              style={{
                background: "#FEFEFE"
              }}
            >
              <div className="loginDiv2">
                <div className="loginPage pt-3">
                  <div className="my-2">
                    <div className="loginLogo me-3 pt-1 pe-1">
                      <img
                        src={require("../../assets/images/Moonliveshop.png")}
                        alt=""
                        width={"80px"}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      color: "#000",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "22px",
                      letterSpacing: "0.48px",
                    }}
                    className=""
                  >
                    <p>Welcome to {projectName} ! </p>
                  </div>
                  <div className=" mb-3">
                    <h3
                      className="text-dark"
                      style={{ fontSize: "30px", fontWeight: "500" }}
                    >
                      Login to your account
                    </h3>
                  </div>
                  <div className="loginInput">
                    <Input
                      label={`Email`}
                      id={`loginEmail`}
                      type={`email`}
                      value={email}
                      style={{ background: "rgba(185, 49, 96, 0.11)" }}
                      errorMessage={error.email && error.email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            email: `Email Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            email: "",
                          });
                        }
                      }}
                    />

                    <Input
                      label={`Password`}
                      id={`loginPassword`}
                      type={`password`}
                      value={password}
                      errorMessage={error.password && error.password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            password: `Password Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            password: "",
                          });
                        }
                      }}
                    />
                  </div>

                  <span className="d-flex align-items-center justify-content-end fw-semibold pdlogin">
                    <a href="/forgotPassword" style={{ color: "#7E7E7E " }}>
                      Forgot password?
                    </a>
                  </span>

                  <div className="d-flex flex-column mt-3" style={{ gap: "10px" }}>
                    <Button
                      newClass={`blackFont`}
                      btnColor={`btnBlackPrime`}
                      style={{
                        borderRadius: "10px",
                        width: "100%",
                        height: "40px",
                        color: "#fff"
                      }}
                      btnName={isLoading ? `Logging In...` : `Log In`}
                      onClick={handleSubmit}
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { loginAdmin })(Login);

